module.exports = __webpack_public_path__ + "static/7-a97522a204571cac63679e7531c7ed9e.jpg";